import { render, staticRenderFns } from "./OverviewWrapper.vue?vue&type=template&id=17e9d4a0&scoped=true&"
import script from "./OverviewWrapper.vue?vue&type=script&lang=js&"
export * from "./OverviewWrapper.vue?vue&type=script&lang=js&"
import style0 from "./OverviewWrapper.vue?vue&type=style&index=0&id=17e9d4a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17e9d4a0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
